import type { AreaDefinition } from '@/world/area';

/**
 * Katie's farm.
 *
 * 40x30 tiles against a 384x216 viewport, so the camera has room on both axes.
 * The cottage door, the path spine and the plot gate line up vertically: the
 * common route — wake, cross the yard, reach the crops — is a straight walk.
 *
 * Legend: . grass  , dark grass  _ tilled soil  = path  ~ water  T tree
 *         # fence  o rock  W cottage wall  D door  K cart  N notice board
 */
export const FARM_AREA: AreaDefinition = {
  id: 'farm',
  name: 'Windrow Farm',
  rows: [
  'TTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTT',
  'T......................................T',
  'T.............,,,,.....................T',
  'T...HHHHHHH...,,,,.....................T',
  'T...HHHHHHH..............T########.....T',
  'T...HHHHHHH...o...........#,,,,,,#.....T',
  'T...HHHHHHH...............#,,,,,,#.....T',
  'T...CVCDCCC...............#,,,,,,#.....T',
  'T......=..........T...=...#,,,,,,#.....T',
  'T......=..............=...#,,,,,,#.....T',
  'T......=....T.........=...#,,,,,,#.....T',
  'T......=..............=...###,,###.....T',
  'T......=..............=.......T........T',
  'T......=..............=...............=T',
  'T...====================================',
  'T..................N..=.K..............T',
  'T.....................=................T',
  'T..####_####..........=................T',
  'T..#_______#..........=......~~~~~~~...T',
  'T..#_______#..........=.....~~~~~~~~~..T',
  'T..#_______#.o........=.....~~~~~~~~~..T',
  'T..#_______#..........=.....~~~~~~~~~..T',
  'T..#########..........=.....~~~~~~~~~..T',
  'T.....................=......~~~~~~~...T',
  'T......================................T',
  'T......................................T',
  'T...............o.......,,,,...........T',
  'T.......................,,,,.......T...T',
  'T......................................T',
  'TTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTT',
  ],
  farmable: true,
  spawn: { x: 7 * 16, y: 9 * 16 },
  portals: [
    { x: 7, y: 7, toArea: 'cottage', toX: 6, toY: 8 },
    // East gap in the tree line, out to the coast.
    { x: 39, y: 14, toArea: 'coast', toX: 30, toY: 2 },
  ],
  // Chickens wander inside the fence, never through the gate.
  pen: { minX: 27, minY: 5, maxX: 32, maxY: 10 },
  trough: { x: 27, y: 5 },
};
